export { Iconify } from "./Iconify";
